import { useState, useEffect } from 'react';
import { SCREEN_WIDTHS } from '../../Constants/screenWidths';



type DeviceType = {
  isMobile: boolean;
  isTablet: boolean;
  isMobileOrTablet: boolean;
  isDesktop: boolean;
  isLargeDesktop: boolean;
};

const useAppMediaQuery = (): DeviceType => {
  const [deviceType, setDeviceType] = useState<DeviceType>({
    isMobile: false,
    isTablet: false,
    isMobileOrTablet: false,
    isDesktop: false,
    isLargeDesktop: false,
  });

  useEffect(() => {
    const handleResize = () => {
      const screenWidth = window.innerWidth;

      setDeviceType({
        isMobile: screenWidth <= SCREEN_WIDTHS.MOBILE,
        isTablet: screenWidth > SCREEN_WIDTHS.MOBILE && screenWidth <= SCREEN_WIDTHS.TABLET,
        isMobileOrTablet: screenWidth <= SCREEN_WIDTHS.TABLET,
        isDesktop: screenWidth > SCREEN_WIDTHS.TABLET && screenWidth <= SCREEN_WIDTHS.DESKTOP,
        isLargeDesktop: screenWidth > SCREEN_WIDTHS.DESKTOP,
      });
    };

    handleResize();
    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  return deviceType;
};

export default useAppMediaQuery;